// extracted by mini-css-extract-plugin
module.exports = {"rootMobile":"BaseFareAttributes-module__rootMobile___N2Jyj","attributeBadge":"BaseFareAttributes-module__attributeBadge___e4MFq"};